import React, { useRef, useImperativeHandle, forwardRef } from 'react';

import { DataChange } from 'devextreme/common/grids';

import FieldGrid, { FieldGridHandle } from './FieldGrid';

import DataTableFieldMappingDto from '../../classes/dtos/pathdatatablemodule/DataTableFieldMappingDto';

import TransformationCapabilitiesDto from '../../classes/dtos/transformationmodule/TransformationCapabilitiesDto';
import PathDataTableMappingCapabilitiesDto from '../../classes/dtos/pathdatatablemodule/PathDataTableMappingCapabilitiesDto';


interface DataTableExposedFieldsProps {
    MappingChanges: DataChange[] | undefined;
    SetMappingChanges(changes: DataChange[], origin: DataTableFieldMappingDto[]): void;

    Capabilities: PathDataTableMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[];
    Mapping: DataTableFieldMappingDto[];
    IsSimpleFilterMode: boolean;
    FiltersEnabled: boolean;
    TableReferenceId: number;

    AdvancedFilterMode: boolean;
    SetAdvancedFilterMode(value: boolean): void;
    AdvancedFilterModeLocked: boolean;

    SelectionIds: number[];
    SetSelectionIds(ids: number[]): void;

    MultipleTables: boolean;
}

export interface DataTableExposedFieldsHandle {
    Save: () => void;
}

const DataTableExposedFields = forwardRef<DataTableExposedFieldsHandle, DataTableExposedFieldsProps>(({ MappingChanges, SetMappingChanges, Capabilities, TransformationsCapabilities, Mapping, IsSimpleFilterMode, FiltersEnabled, TableReferenceId, AdvancedFilterMode, SetAdvancedFilterMode, AdvancedFilterModeLocked, SelectionIds, SetSelectionIds, MultipleTables }, ref) => {

    useImperativeHandle(ref, () => ({
        Save() {
            if (fieldGridRef.current) {
                fieldGridRef.current.Save();
            }
        }
    }));

    const fieldGridRef = useRef<FieldGridHandle>(null);

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
            <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
                <FieldGrid
                    ref={fieldGridRef}
                    MappingChanges={MappingChanges}
                    SetMappingChanges={SetMappingChanges}

                    Capabilities={Capabilities}
                    TransformationsCapabilities={TransformationsCapabilities}
                    Mapping={Mapping}
                    IsSimpleFilterMode={IsSimpleFilterMode}
                    FiltersEnabled={FiltersEnabled}
                    TableReferenceId={TableReferenceId}
                    AdvancedFilterMode={AdvancedFilterMode}
                    SetAdvancedFilterMode={SetAdvancedFilterMode}
                    AdvancedFilterModeLocked={AdvancedFilterModeLocked}
                    SelectionIds={SelectionIds}
                    SetSelectionIds={SetSelectionIds}
                    MultipleTables={MultipleTables}
                />
            </div>
        </div>
    );
});

export default DataTableExposedFields;